import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { WebchatWindow } from './';

const Webchat = ({ children }) => {
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    try {
      if (window && window.Genesys) {
        window.Genesys('subscribe', 'Messenger.ready', () => {
          setDisabled(false);
        });

        window.Genesys('subscribe', 'Messenger.closed', () => {
          setDisabled(false);
          setActive(false);
          window.Genesys('command', 'Launcher.hide');
        });

        window.Genesys('subscribe', 'Messenger.opened', () => {
          setDisabled(true);
          setLoading(false);
        });
      }
    } catch {
      setDisabled(true);
    }
  }, []);

  const handleClick = () => {
    setActive(true);
    setLoading(true);

    window.Genesys('command', 'Messenger.open');
  };

  return (
    <>
      {active && <WebchatWindow active={active} />}
      {children({
        onClick: handleClick,
        disabled,
        loading,
      })}
    </>
  );
};

Webchat.defaultPropTypes = {
  //
};

Webchat.propTypes = {
  children: PropTypes.func.isRequired,
};

export default Webchat;
